export enum EVideoEvents {
    INIT = 'video:init',
    PRELOAD = 'video:preload',
    PLAY_STARTED = 'video:play:started',
    PAUSE = 'video:pause',
    META_LOADED = 'video:meta:loaded',
}
